import '../scss/main.scss';
import './react/agenda';

import Nav from './components/Nav';
import LoadImage from './components/LoadImage';
import Accordion from './components/Accordion';
import IsDraggable from './components/IsDraggable';
import HideOnScroll from './components/HideOnScroll';
import NavAccordion from './components/NavAccordion';
import ButtonTickets from './components/ButtonTickets';
import VideoPlayer from './components/VideoPlayer';
import SliderNav from './components/SliderNav';
import Countdown from './components/Countdown';
import Pagination from './components/Pagination';


import EagerlyMailSubscription from './components/EagerlyMailSubscription';

document.querySelectorAll('.js-nav').forEach((el) => {
	new Nav(el);
});

document.querySelectorAll('.js-load-image').forEach((el) => {
	new LoadImage(el);
});

document.querySelectorAll('.js-accordion').forEach((el) => {
	new Accordion(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
	new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
	new HideOnScroll(el);
});

document.querySelectorAll('.js-nav-accordion').forEach((el) => {
	new NavAccordion(el);
});

document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
});


// Newsletter Sign up
document.querySelectorAll('.js-newsletter').forEach((el) => new EagerlyMailSubscription(el));

document.querySelectorAll('.js-button-register').forEach((el) => {
	new ButtonTickets(el);
});

document.querySelectorAll('.js-slider-section').forEach((el) => {
	new SliderNav(el);
});

//ticketButtonCountdown
document.querySelectorAll('.js-countdown').forEach((el) => {
	new Countdown(el);
});

//pagination
document.querySelectorAll('.js-pagination').forEach((el) => {
	new Pagination(el);
});

